export default __webpack_public_path__ + "static/media/bgCircle.d873c92c.svg";